<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span><a id="page_viii">Author’s Note</a></span></p><a id="page_viii">
<p class="normal">My thanks to Open Road Media for including <i>Deadly Deceits</i> in its Forbidden Bookshelf ebook series.</p>
<p class="indent">My purpose in writing <i>Deadly Deceits</i> a generation ago was to inform the public about how the CIA distorted intelligence reports, including mine, on the Vietnam War to support White House political goals. I had to obtain a court order against the agency to get the book published in its original form. I felt it was vital, however, to alert the public that many intelligence reports from the CIA could not be trusted.</p>
<p class="indent">It remains as important today as it was in the Vietnam era for the public to hold the CIA accountable when its reporting reflects political purposes instead of accurate intelligence.</p>
<p class="indent">My hope is that this ebook publication of <i>Deadly Deceits</i> will serve as a reminder that watching the watchers—the CIA and other intelligence agencies—may be the best way to keep them from straying from their legitimate intelligence-gathering mission.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter02.vue?71d286d8